module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-35.6081e597.svg";